module.exports = __webpack_public_path__ + "img/especialistas.e4e40c9f.jpg";